import React from 'react';
import {
  useLocation,
} from 'react-router';
import {
  useObserver,
} from 'mobx-react';
import {
  convertToRaw,
} from 'draft-js';
import * as yup from 'yup';
import GeneralFormView from '../../components/GeneralFormView';
import GeneralFormFields, {FormFieldActions} from '../../components/GeneralFormView/types';
import {
  FormFieldsBuilder,
} from '../../components/GeneralFormView/Utils/FormFieldsBuilder';
import {
  RequestStatus,
  stores,
} from '../../mobx-store';
import {
  ReleaseNotesDTO,
} from './DTOs/releaseNotesDTO';
import {
  ReleaseNotesFormViewModel,
} from './DTOs/releaseNotesFormViewModel';
import {
  languageCodes,
} from '../../constants/languages';
 import Condition, {
   ConditionStatement,
   ConditionalStatementTypes,
   ConditionExpression,
 } from '../../components/GeneralFormView/Utils/Condition';
const AddEditReleaseNotesScreen: React.FC = () => {
  const mapToDTO = (formValue: ReleaseNotesFormViewModel): ReleaseNotesDTO => ({
    releaseNotesId: formValue.releaseNotesId,
    isActive: formValue.isActive,
    title: formValue.title,
    body: JSON.stringify(convertToRaw(formValue.body.getCurrentContent())),
    appVersion: formValue.appVersion,
  });

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const paramLang = queryParams.get('lang');

  const {
    formFields,
  } = new FormFieldsBuilder<ReleaseNotesFormViewModel>()
    .addField('title', {
      fieldOptions: {
      },
      condition: (values, actions, location) =>new Condition({
        values,
        initialStatement: new ConditionStatement({
          action: actions[FormFieldActions.DISABLE],
          type: ConditionalStatementTypes.IF,
          expression: new ConditionExpression({
            values,
            expression: (val) => true,
          }),
        }),
      }),


      hasTranslations: true,
      title: paramLang === languageCodes.arabic ? ' Arabic Title' : 'English Title',
      type: GeneralFormFields.INPUT_FIELD,
      validationSchema: yup.string().required('Required'),
    })
    .addField('isActive', {
      hasTranslations: false,
      title: 'Active',
      type: GeneralFormFields.TOGGLE_FIELD,
      fieldOptions: {

      },
      validationSchema: yup.boolean().required(),
    })
    .addField('body', {
      fieldOptions: {
        editorProps: {
          toolbar: {
            options: [
              'inline', 'blockType', 'fontSize', 'fontFamily',
              'list', 'textAlign', 'colorPicker', 'link', 'emoji',
              'remove', 'history',
            ],
          },
        },
      },
      hasTranslations: true,
      title: paramLang === languageCodes.arabic ? ' Arabic Body' : 'English Body',
      type: GeneralFormFields.RICH_TEXT_FIELD,
    })
    .addField('appVersion', {
      hasTranslations: false,
      title: 'App Version',
      type: GeneralFormFields.INPUT_FIELD,
      fieldOptions: {
      },
      validationSchema: yup.string()
        .matches(/^(0|[1-9]\d*)(\.(0|[1-9]\d*)){0,3}$/, 'Invalid version number')
        .required('Required'),
    });

  return useObserver(() => (
    <GeneralFormView<ReleaseNotesDTO, ReleaseNotesFormViewModel>
      defaultLang="ar"
      title="Release Notes"
      identifier="releaseNotesId"
      otherLanguages={['en']}
      formData={formFields}
      create={async (formValue) => {
        const dto = mapToDTO(formValue);
        const res = await stores.releaseNotesStore.createNewReleaseNotes(dto);
        return res;
      }}
      update={async (id, formValue, language) => {
        const dto = mapToDTO(formValue);
        await stores.releaseNotesStore.updateReleaseNotesById(Number(id), dto, language);
      }}
      get={async (id, language) => {
        await stores.releaseNotesStore.getReleaseNotesById(Number(id), language);
        return new ReleaseNotesFormViewModel(stores.releaseNotesStore.currentReleaseNotes as ReleaseNotesDTO);
      }}
      isFetchSuccessful={stores.releaseNotesStore.createOrUpdateStatus === RequestStatus.SUCCESS}
      createOrUpdateStatus={stores.releaseNotesStore.createOrUpdateStatus}
    />
  ));
};

export default AddEditReleaseNotesScreen;
